<script lang="ts">
  import TextNew from "./TextNew.svelte";

  export let isActive = false;
</script>

<button class="date-btn" class:btn-active={isActive} on:click>
  <TextNew as="span" size="xs" weight="medium">
    <slot />
  </TextNew>
</button>

<style>
  .date-btn {
    display: flex;
    padding: 6px 16px;
    justify-content: center;
    align-items: center;
    border-radius: 100px;
  }

  .btn-active {
    background-color: var(--rekki-light);
  }
</style>
